import { render, staticRenderFns } from "./ConsequenceList.vue?vue&type=template&id=722ce645&scoped=true"
import script from "./ConsequenceList.vue?vue&type=script&lang=js"
export * from "./ConsequenceList.vue?vue&type=script&lang=js"
import style0 from "./ConsequenceList.vue?vue&type=style&index=0&id=722ce645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ce645",
  null
  
)

export default component.exports